<template>
    <div class="contactUsRight">
        <div class="message_list1">
            <div class="message_list2 flex-row"><span>联系我们</span> <span class="cursor_1 t-m-l-20">扫码可在线联系客服</span></div>
            <div class="t-m-t-10">
                <!-- <img class="gzh1" src="@/assets/image/home/wx-lxkf.png" width="146" height="144" alt=""> -->
                 <img class="gzh1" src="@/assets/image/home/wx-lxkf-1.png" width="146" height="144" alt="">
            </div>
        </div>
        <!-- 举报建议表单 -->
        <div class="message_list1 t-m-b-22" style="padding-bottom: 10px;padding-top:10px;">
            <div class="message_list2">举报建议</div>
        </div>
        <div class="t-p-l-7 t-p-r-50">
            <el-form label-position="top" label-width="80px" :model="feedback">
                <el-form-item label="请填写内容">
                    <div class="generator_contentText">
                        <el-input v-model="feedback.content" type="textarea" :maxlength="maxlength"
                            :autosize="{ minRows: 3, maxRows: 5 }"
                            placeholder="您遇到了什么问题？或者有什么建议？欢迎您反馈给我们，谢谢您的宝贵意见！"></el-input>
                        <div class="generator_contentText1">
                            <div class="generator_contentText1_1 cursor_1" @click="feedback.content = ''">
                                <img src="@/assets/image/icon_del.png" alt="">
                            </div>
                            <div class="generator_contentText1_2">{{ feedback.content.length }}/{{ maxlength }}</div>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item label="联系方式">
                    <div class="generator_contentText">
                        <el-input v-model="feedback.contact" :maxlength="18" show-word-limit
                            placeholder="留下您的微信号或者QQ号"></el-input>
                    </div>
                </el-form-item>
                <el-form-item label="上传图片（最多3张）">
                    <ImageUpload :uploadUrl="updateUrl" :fileList.sync="feedback.imgs" :headers="headers" :maxSize="2" :limit="3"/>
                </el-form-item>
                <el-form-item>
                    <div class="flex-row-center">
                        <el-button @click="tjSumbit" type="primary" :loading="loading" style="width: 211px;height: 41px;" round>提交</el-button>
                    </div>
                </el-form-item>
            </el-form>
        </div>

        <!-- 举报建议表单 -->

    </div>
</template>
<script>
import ImageUpload from '@/components/dongeb/ImageUpload.vue';
import CApi from '@/api/contactUs.js'
export default {
    components: {
        ImageUpload
    },
    data() {
        return {
            loading:false,
            updateUrl: process.env.VUE_APP_BASE_API + "/file/upload", //上传地址
            headers: {
                'Content-Type': 'multipart/form-data',
                'Authorization': localStorage.getItem('token_key')
            }, //请求头
            maxlength: 1000,
            feedback: {
                contact: '',//联系方式
                content: '',//内容
                imgs: [],//照片 提交用( , 号分隔)
            }
        }
    },
    created(){
         this.getUserLoginState(false)
    },
    methods: {
        tjSumbit(){
            if (this.showLoginPage()) return
            let data = {
                ...this.feedback,
                imgs: this.feedback.imgs.length > 0 ? this.feedback.imgs.map(item=>item.url).join(',') : ''
            }
            // console.log('打印提交结果=',data)
            if(!this.clearText(data.content.trim()) || this.clearText(data.content.trim()).length < 10){
                this.$message.warning('请填写至少10个字内容')
                return
            }
            if(!this.clearText(data.contact.trim())){
                this.$message.warning('请填写联系方式')
                return
            }
            this.loading = true
            CApi.feedback(data).then(res=>{
                if(res.code === 200){
                     this.$message.success('感谢您的反馈，我们会及时处理！')
                     this.feedback = this.$options.data().feedback
                }else{
                    this.$message.warning(res.msg)
                }
                this.loading = false
            }).catch(()=>{
                this.loading = false
            })
        }
    }
}
</script>
<style lang="scss" scoped>
.contactUsRight {
    width: 493px;
    flex-shrink: 0;
    height: 100%;
    margin-left: 56px;
    background-color: #FFFFFF;
}

.message_list1 {
    padding: 20px 7px;
    border-bottom: 1px solid #E6EBF0;
}

.message_list2 {
    font-size: 18px;
    color: #0B0B0B;
    font-weight: bold;

    span:first-child {

        font-size: 18px;
        color: #0B0B0B;
    }

    span:last-child {
        font-weight: normal;
        font-size: 15px;
        color: #666666;
    }
}

.message_list3 {
    display: flex;
}

::v-deep(.el-upload--picture-card) {
    height: 86px !important;
    width: 86px !important;
    line-height: 86px !important;
}

::v-deep(.el-input) {
    .el-input__inner {
        width: 100%;
        background-color: #F8F8F8;
        resize: none;
        font-size: 15px;
        border: none;
    }

    .el-input__count-inner {
        background-color: transparent !important;
        color: #444444;
    }
}

::v-deep(.el-form) {
    .el-form-item__label {
        font-family: Microsoft YaHei;
        font-weight: 400;
        font-size: 18px;
        color: #333333;
        line-height: 1;
        padding: 0 0 15px 0;
    }
}
</style>